import axios from "../http_v2";
// 添加渠道
let add = data => {
  return axios.post("marketcenter/urlChannel/save/channelTemplate", data);
};
// 删除渠道
let del = data => {
  return axios.get("marketcenter/urlChannel/remove/channelTemplate", data);
};
// 渠道列表
let list = data => {
  return axios.post("marketcenter/urlChannel/page/channelTemplate", data);
};
// 添加渠道分类
let addType = data => {
  return axios.post("marketcenter/urlChannel/save/channeltype", data);
};
// 删除渠道分类
let delType = data => {
  return axios.get("marketcenter/urlChannel/remove/channelType", data);
};
// 渠道分类列表
let typeList = params => {
  return axios.get("marketcenter/urlChannel/page/channelType", params);
};

let urlChannel = data => {
  return axios.get("marketcenter/urlChannel/get/urlChannel", data);
};
// 活动的渠道列表
let urlChannelList = data => {
  return axios.post("marketcenter/urlChannel/page/channel", data);
};

// 渠道总数
let channelSum = data => {
  return axios.post("marketcenter/urlChannel/page/channel_sum", data);
};

let addUrlChannel = data => {
  return axios.post("marketcenter/urlChannel/add/channel", data);
};

let delUrlChannel = data => {
  return axios.get("marketcenter/urlChannel/delete/channel", data);
};

let noneUrlChannelCount = data => {
  return axios.get("marketcenter/urlChannel/get/not/urlcode/count", data);
};
let getTree = data => {
  return axios.get("activityservice/contactOrg/tree", data);
};

export default {
  add,
  del,
  list,
  addType,
  delType,
  typeList,
  addUrlChannel,
  delUrlChannel,
  urlChannelList,
  urlChannel,
  noneUrlChannelCount,
  channelSum,
  getTree
};
